import React, {useRef} from 'react'
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import styled from "@emotion/styled";
import sv from "../styles/marketing";
import examplesHeadImage from "../../public/img/examples/ondeck-legal.jpg";
import Footer from "../components/Footer";
import {ExampleCollection} from "../components/examples/ExampleCollection";
import {useHistory} from "react-router-dom";
import {GetStartedPitch} from "../components/pitch/GetStartedPitch";
import {useTranslation} from "react-i18next";
import {useSize} from "../hooks/commons/RefSize";
import {__isKeyAvailable} from "../_helpers";

// STYLE ##########################################################

const extendedHeaderMinHeight = 600;

const HeaderStretchedContainer = styled(`div`)`
  width: 100%;
  ${sv.flexColumn}
  min-height: ${extendedHeaderMinHeight}px;
`;

const ImageBackground = styled('div')`
  position: absolute;
  right: 0;
  width: 100%;
  min-height: ${extendedHeaderMinHeight}px;
  background-image: url("${examplesHeadImage}");
  background-position: ${props => props.parentWidth < 850 ? "70%" : "100%"} 50%;
  background-size: ${extendedHeaderMinHeight*2}px ${extendedHeaderMinHeight}px;
  opacity: 0.7;
  z-index: -999;
`;

const GradientBackground = styled(`div`)`
  position: absolute;
  left: 0;
  width: 100%;
  min-height: ${extendedHeaderMinHeight}px;
  background: linear-gradient(to right, black ${props => props.parentWidth ? ((-0.02 * props.parentWidth) + 67) : 0}%, rgba(255, 0, 0, 0)); // y=mx+c : [1200, 40] & [300,60]
  z-index: -998;
`;

const HeaderBlock = styled(`div`)`
  width: ${props => props.parentWidth ? ((-0.06 * props.parentWidth) + 97) : 0}vw;  // y= mx+c : [1200,30] & [300,80]
  min-width: 220px;
  max-width: 500px;
  ${sv.flexColumn};
  flex-grow: 1;
  justify-content: center;
`;

const Title = styled('h1')`
  ${sv.title};
  width: 100%;
  text-align: start;
  color: ${sv.colors.light};
`;

const Invite = styled('p')`
  ${sv.h3};
  width: 100%;
  text-align: start;
  font-weight: 300;
  margin-bottom: 8px;
  margin-top: 40px;
  color: ${sv.colors.light}
`;

const Section = styled('div')`
  display: flex;
  flex-direction: column;
`;

const Divider = styled(`hr`)`
  width: 100%;
`;

const PitchButton = styled('div')`
  font-size: 15px;
  ${sv.buttonBase};
  background: ${sv.colors.cta};
  color: ${sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
  margin: 32px 0;
`;

// COMPONENT ##########################################################

const getExampleCollections = (t) => {
  return {
    blocks: [{
      title: t("Business"),
      isInfoPresent: true,
      info: {
        title: t("Improve efficiency."),
        text: t("Find that moment from last week’s staff meeting in less than a minute!"),
      },
      examples: [{
        link: "/play/founders-interview",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/e8164dbb-d5e2-48ff-b49a-4415256e18e1/founders_video_og_6.png",
        title: t("Interview - Gistify's Founder"),
      }, {
        link: "/play/67ed669a-7dc3-47be-9eb2-8c769f5f0ce9",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/67ed669a-7dc3-47be-9eb2-8c769f5f0ce9/67ed669a-7dc3-47be-9eb2-8c769f5f0ce9_og-2.png",
        title: t("Focus Group - Zoom Recording (Gallery View)"),
      }, {
        link: "/play/19307529-fa03-43dd-a5ce-28619a546499",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/19307529-fa03-43dd-a5ce-28619a546499/19307529-fa03-43dd-a5ce-28619a546499_share.png",
        title: t("Focus Group - Zoom Recording (Speaker View)"),
      }, {
        link: "/play/2650c1c7-5cd4-4e6d-928f-fde9dc1c7b23",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F2650c1c7-5cd4-4e6d-928f-fde9dc1c7b23%2F2650c1c7-5cd4-4e6d-928f-fde9dc1c7b23.svg?generation=1617207117486983&alt=media",
        title: t("Focus Group - Zoom Recording (Audio Only)"),
      }]
    }, {
      title: t("Education"),
      isInfoPresent: true,
      info: {
        title: t("Never miss a key point."),
        text: t("No more endless video clicking to find what you need from your lectures."),
      },
      examples: [{
        link: "/play/893db63f-23cb-4d45-9357-089351f1754d",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F893db63f-23cb-4d45-9357-089351f1754d%2F893db63f-23cb-4d45-9357-089351f1754d_share.jpeg?generation=1587150178467662&alt=media",
        title: "Business Fights Poverty - Oxford Series - Andrew Hunt",
      }, {
        link: "/play/3b2a0b9b-730c-4a49-8ec7-e820388c7ca8",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F3b2a0b9b-730c-4a49-8ec7-e820388c7ca8%2F3b2a0b9b-730c-4a49-8ec7-e820388c7ca8_share.jpeg?generation=1619820869533746&alt=media",
        title: t("Surveillance Capitalism In Today’s Digital Age - Fortune Global Forum"),
      }, {
        link: "/play/4f55fa02-7538-4e5b-b3e9-88ff8f5c1699",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F4f55fa02-7538-4e5b-b3e9-88ff8f5c1699%2F4f55fa02-7538-4e5b-b3e9-88ff8f5c1699_share.jpeg?generation=1587150179083614&alt=media",
        title: t("Fall Lecture Series - Peter Calthorpe"),
      }, {
        link: "/play/4ff498a6-b3a1-418f-b61c-67ca454e7fe3",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F4ff498a6-b3a1-418f-b61c-67ca454e7fe3%2F4ff498a6-b3a1-418f-b61c-67ca454e7fe3_share.jpeg?generation=1587150183503611&alt=media",
        title: t("Lecture on Natural Language Processing with Deep Learning"),
      }, {
        link: "/play/fb2c6a35-2991-44f5-b401-214e3a5aa351",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2Ffb2c6a35-2991-44f5-b401-214e3a5aa351%2Ffb2c6a35-2991-44f5-b401-214e3a5aa351_share.jpeg?generation=1587150182922805&alt=media",
        title: t("Lecture on Darwin's Legacy - Professor William Durham"),
      }, {
        link: "/play/6275ecb0-5037-4628-82cc-d8f32425bb4e",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F6275ecb0-5037-4628-82cc-d8f32425bb4e%2F6275ecb0-5037-4628-82cc-d8f32425bb4e_share.jpeg?generation=1587150178318262&alt=media",
        title: t("Folding Paper, Polymers, and Robots - Origami and Math"),
      }]
    }, {
      title: t("Legal & Compliance"),
      isInfoPresent: true,
      info: {
        title: t("Save yourself time."),
        text: t("Never miss a beat with your clients. Crush your depositions with Gistify."),
      },
      examples: [{
        link: "/play/legal-use-case",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/940e2070-91f2-459d-aeb4-86c0d89fcdab/ondeck-legal-og-2.png",
        title: t("Gistified Legal Use Case - Video Interview"),
      }, {
        link: "/play/349f68f3-9951-46be-9128-feb5031977b0",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F349f68f3-9951-46be-9128-feb5031977b0%2F349f68f3-9951-46be-9128-feb5031977b0.jpeg?generation=1614647516917823&alt=media",
        title: t("Gistified Legal Deposition - Misconduct by Attorney Witness"),
      }, {
        link: "/play/6e07f90f-3601-4f75-aa56-7e17dcbc8d7e",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F6e07f90f-3601-4f75-aa56-7e17dcbc8d7e%2F6e07f90f-3601-4f75-aa56-7e17dcbc8d7e.jpeg?generation=1623872826324345&alt=media",
        title: t("Misdemeanor Arraignments 3B District Court (June 15, 2021)"),
      }, {
        link: "/play/b82b2ec4-fb7a-4856-8ed2-d26baaeba73a",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2Fb82b2ec4-fb7a-4856-8ed2-d26baaeba73a%2Fb82b2ec4-fb7a-4856-8ed2-d26baaeba73a.jpeg?generation=1623874353157049&alt=media",
        title: t("Probation Violation Arraignments 3B District Court (June 16, 2021)"),
      }]
    }, {
      title: "Research & Interviews",
      isInfoPresent: true,
      info: {
        title: "Scan for relevance.",
        text: "Cycle through Gistify’s “rolling abstract” to identify that focus of words and phrases that is key to your topic.",
      },
      examples: [{
        link: "/play/783ef332-3f9b-453d-8535-03a57f44f14e",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/783ef332-3f9b-453d-8535-03a57f44f14e/stanford-both-mini.jpg",
        title: "Bill Gates & Dean Lloyd Minor Fireside Chat",
      }, {
        link: "/play/566fa813-7aca-4777-a836-f0e17ddab9c8",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F566fa813-7aca-4777-a836-f0e17ddab9c8%2F566fa813-7aca-4777-a836-f0e17ddab9c8_mini.jpeg?generation=1587150135670905&alt=media",
        title: "The Speech that Defined a Presidency",
      }, {
        link: "/play/19caaddf-a1fa-4ff4-bf8e-3f97a0dbb0d0",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F19caaddf-a1fa-4ff4-bf8e-3f97a0dbb0d0%2F19caaddf-a1fa-4ff4-bf8e-3f97a0dbb0d0_mini.jpeg?generation=1587150134299584&alt=media",
        title: "Defending the Nation with Secretary of Defense James Mattis",
      }]
    }, {
      title: "Podcasts & Audio Books",
      isInfoPresent: true,
      info: {
        title: "See what you’re listening to.",
        text: "Gistified audio content makes the essence of the content visible for the first time.",
      },
      examples: [{
        link: "/play/5f0a48bf-8956-497c-96fb-976ee7bac9be",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F5f0a48bf-8956-497c-96fb-976ee7bac9be%2F5f0a48bf-8956-497c-96fb-976ee7bac9be_mini.jpeg?generation=1587957876631315&alt=media",
        title: "Joe Rogan Experience #1386 - Matt Taibb - Video Podcast",
      }, {
        link: "/play/f4ea1d80-2d68-4ade-8eb5-d9167ee3d7d9",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2Ff4ea1d80-2d68-4ade-8eb5-d9167ee3d7d9%2Ff4ea1d80-2d68-4ade-8eb5-d9167ee3d7d9.svg?generation=1574372618800573&alt=media",
        title: "The Fall of the Aztecs - Audio Podcast",
      }, {
        link: "/play/42c45ff2-22a2-477a-b35c-a99ccdb96b7a",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F42c45ff2-22a2-477a-b35c-a99ccdb96b7a%2F42c45ff2-22a2-477a-b35c-a99ccdb96b7a_mini.jpeg?generation=1587150126639612&alt=media",
        title: "The Rachel Maddow Show - McConnell at Nexus of Increased Russian Leverage on U.S.",
      }]
    }, {
      title: "Politics & News",
      isInfoPresent: true,
      info: {
        title: "Scanning, with search, optimizes value.",
        text: "Combine the Gist with an advanced, visual search to create the best experience.",
      },
      examples: [{
        link: "/play/obama_state_of_the_union_2011",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/obama_state_of_the_union_2011/obama_state_of_the_union_2011.png",
        title: "President Obama : State of the Union Address (2011)",
      }, {
        link: "/play/bush_state_of_the_union",
        imageSrc: "https://storage.googleapis.com/timecloud-gogist-bucket/gistPipeline/persist/bush_state_of_the_union/bush_state_of_the_union.png",
        title: "President George W. Bush : State of the Union Address (2002)",
      }, {
        link: "/play/73488f76-a986-4043-833b-758f86662267",
        imageSrc: "https://www.googleapis.com/download/storage/v1/b/timecloud-gogist-bucket/o/gistPipeline%2Fpersist%2F73488f76-a986-4043-833b-758f86662267%2F73488f76-a986-4043-833b-758f86662267_mini.jpeg?generation=1587150120902819&alt=media",
        title: "Obama White House Correspondents Dinner (2016)",
      }]
    // }, {
    //   title: "Government / Audio & Video",
    //   isInfoPresent: false,
    //   info: {
    //     title: "",
    //     text: "",
    //   },
    //   examples: [{
    //     link: "/play/a6023d2a-4a2d-49fc-b2f1-e3c90c23aa1f",
    //     imageSrc: defaultThumbnailURL,
    //     title: "North Dakota Dept of Commerce Meeting",
    //   }]
    }]
  }
}

export function Examples() {
    const history = useHistory();
    const {t} = useTranslation("examples");
    const collections = getExampleCollections(t);
  
    const headRef = useRef(null);
    const size = useSize(headRef);
    const headWidth = (__isKeyAvailable(size, "width")) ? size.width : 0;
    
    return (
        <StyledMedia>
          <Container isMobile={isMobileOnly}>
            <HeaderStretchedContainer ref={headRef}>
              {/* image background */}
              <ImageBackground parentWidth={headWidth} />
              
              {/* gradient background */}
              <GradientBackground parentWidth={headWidth} />
              
              {/* actual header */}
              <Header lightColor pageTitle={t("Examples")}/>
  
              {/* header other block */}
              <HeaderBlock parentWidth={headWidth}>
                <Title>{t("Explore our Gistified videos")}</Title>
                <Invite>{t("Select any example to view the Gist, an interactive “rolling abstract”, and efficiently identify relevant, key points from video and audio content.")}</Invite>
                <PitchButton onClick={() => history.push('/signup')}>Get Started</PitchButton>
              </HeaderBlock>
            </HeaderStretchedContainer>
  
            {/* examples block */}
            <Section>
              {
                collections.blocks.map((currentCollection, i, arr) => {
                  return <React.Fragment key={i}>
                    {/* collection */}
                    <ExampleCollection collectionInstance={currentCollection} />
                    
                    {/* add divide if not last one */}
                    { arr.length -1 !== i  &&
                    <Divider />
                    }
                  </React.Fragment>
                })
              }
            </Section>
  
            {/* pitch */}
            <GetStartedPitch />
  
            <Footer isMobile={isMobileOnly} />
            
          </Container>
        </StyledMedia>
    );
}
